var _effectorFileName = "/builds/gmini/ui-common/src/helpers/iframeContainer.tsx";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import ReactDOM from 'react-dom';
import { CircularProgress } from '../CircularProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export function destroyElement(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
}
export var createContainer = function createContainer(_ref) {
  var uid = _ref.uid,
      frame = _ref.frame,
      prerenderFrame = _ref.prerenderFrame,
      doc = _ref.doc,
      event = _ref.event,
      dimensions = _ref.dimensions;
  var width = dimensions.width,
      height = dimensions.height;
  var div = doc.createElement('div');
  div.setAttribute('id', uid);
  var style = doc.createElement('style');
  style.textContent = "\n    .iframeContainer {\n      display: flex;\n      flex: 1;\n      height: 100%;\n    }\n    #".concat(uid, " {\n        width: ").concat(width, ";\n        height: ").concat(height, ";\n    }\n    #").concat(uid, " > iframe {\n        width: 100%;\n        height: 100%;\n        border-radius: 4px;\n    }\n}\n");
  doc.head.appendChild(style);
  div.appendChild(frame);
  prerenderFrame.style.display = 'none';
  div.appendChild(prerenderFrame);
  frame.classList.add('zoid-visible');
  event.on('zoid-rendered', function () {
    var parentElement = div.parentElement;

    if (parentElement) {
      parentElement.classList.add('iframeContainer');
    }

    var loader = doc.getElementById('iframe-loader');

    if (loader) {
      loader.remove();
    }

    setTimeout(function () {
      destroyElement(prerenderFrame);
    }, 1);
  });
  return div;
};
export var createPrerenderContainer = function createPrerenderContainer(_ref2) {
  var doc = _ref2.doc;
  var html = doc.createElement('html');
  var body = doc.createElement('body');
  var container = doc.createElement('div');
  html.appendChild(body);
  body.appendChild(container);
  ReactDOM.render(
  /*#__PURE__*/
  //TODO разобраться, почему typescript ругается на это
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  _jsx(CircularProgress, {}), document.getElementById('iframe-loader'));
  return html;
};